import TitleRed from "../../images/who-we-are/title-bg.svg";
import { useQuery } from "convex/react";
import { Link } from "react-router-dom";

function Blog() {
  const offers = useQuery("offers:get") || [];

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <section id="blog" className="bg-white ">
        <div className="container page-padding py-[10rem]">
          {/* title div -- */}
          <div className="flex flex-col text-center relative items-center">
            <p className="text-white relative z-10 text-[15px] uppercase font-bold mb-8">
              Latest Offers
            </p>
            <img
              src={TitleRed}
              alt="text_bg"
              className="w-[23rem] absolute -top-[10px]"
            />

            <h2 className="text-[3.4rem] font-bold mb-4">Offers & Announcements</h2>
            <p className="text-[#646464] font-medium text-[15px] ">
              Stay updated with our latest offers, promotions
              <br /> and announcements.
            </p>
          </div>

          {/* offer cards - text only, from Convex */}
          <div className="flex gap-6 w-full mt-[5rem] md1200:justify-center flex-wrap">
            {offers.length > 0 ? (
              offers.slice(0, 3).map((offer) => (
                <div key={offer._id} className="w-[37rem] min540:w-[100%] shadow-xl flex flex-col px-[3rem] py-[5rem]">
                  {/* date */}
                  <p className="text-[15px] font-bold text-[#323232] border-[#323232] border-solid rounded-full border-[1px] w-fit px-5 py-2 mb-6">
                    {new Date(offer.timestamp).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric"
                    })}
                  </p>
                  {/* title */}
                  <h3 className="text-[22px] font-bold py-5">{offer.title}</h3>
                  {/* desc */}
                  <p className="text-[15px] text-[#646464] font-medium">{offer.description}</p>
                  {/* blog cta */}
                  <Link
                    to="/blog"
                    onClick={goTop}
                    className="text-[15px] uppercase font-bold mt-10 w-[16rem] h-[5rem] bg-[#FF0336] text-white text-center pt-[14px]"
                  >
                    Read more &nbsp; <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-20 bg-gray-50 rounded-3xl border border-dashed border-gray-300 w-full">
                <p className="text-[2rem] font-bold text-gray-400 uppercase tracking-widest">No Offers Currently Available</p>
                <p className="text-[1.4rem] text-gray-400 mt-4">Check back soon for new promotions!</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog;
